import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelected: false
        }
    }
    
    clear() {
        this.setState({
            isSelected: false
        })
        this.inputEle.value = '';
        if (this.props.onClear) {
            this.props.onClear();               
        }
    }

    getLabelText() {
        if (this.state.isSelected) {
            return this.inputEle.files[0].name;
        } else {
            return 'Choose';
        }
    }
    render() {
        return (<><div className={`${this.props.className} p-buttonset btn3`}>
            <Button
                icon={`pi ${this.state.isSelected ? 'pi-upload': 'pi-plus'}`} 
                onClick={e => {
                    if (this.state.isSelected) {
                        this.props.uploadHandler(this.inputEle)
                    } else {
                        this.inputEle.click();
                    }
                }}/>
            <Button 
                label={this.getLabelText()}
                onClick={e => {
                    if (this.state.isSelected) {
                        this.props.uploadHandler(this.inputEle)
                    } else {
                        this.inputEle.click();
                    }
                }}/>
            {this.state.isSelected && <Button 
                onClick={e => {
                    this.clear()
                }}
                icon="pi pi-times-circle" />
            }
        </div>
        <input 
        ref={el => this.inputEle = el}
        style={{display: 'none'}}
        type='file' 
        onChange={e => {
            this.setState({
                isSelected: true
            })
            if (this.props.onSelect) {
                this.props.onSelect(e);
            }
        }} 
        multiple={this.props.multiple} 
        accept={this.props.accept || "*"} />
    </>
    )
    }
}
FileUpload.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    accept: PropTypes.string,
    multiple: PropTypes.bool,
    uploadHandler: PropTypes.func,
    onClear: PropTypes.func,
    onSelect: PropTypes.func
}

export {FileUpload};